import React from "react";
import TermsArticle from "../../components/terms/terms-article";

const TermsAcceptance = () => {
  const handleAccept = (event) => {
    event.preventDefault();
    window.location.href = "https://app.minigoal.it/pages/terms/acceped";
  };

  return (
    <div className="min-h-screen bg-white text-gray-900">
      <div className="mx-auto max-w-4xl px-6 py-12">
        <h1 className="mb-8 text-3xl font-semibold">
          Termini e Condizioni di Minigoal
        </h1>
        <TermsArticle />
        <div className="mt-12 border-t border-gray-200 pt-6">
          <button
            type="button"
            onClick={handleAccept}
            className="inline-flex items-center rounded-md bg-sky-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-sky-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-600"
          >
            Accetto i termini e le condizioni
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsAcceptance;
